export default "__VITE_ASSET__pGpQeyER__"